import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import {
  Container,
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Fade,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Zoom,
  Tabs,
  Tab,
  InputAdornment,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import mokedShahal from "../Moked_Shahal_51.jpg";
import logo from "../logo_shl.png";
import auth from "../Services/loginService";
import resultsService from "../Services/resultsService";

function Login(props) {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [ifOtp, setIfOtp] = useState(true);
  const [openOtpDialog, setOpenOtpDialog] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  useEffect(() => {
    document.title = "רשומה רפואית: התחברות";
    if (props.userDetails) navigate("/");
  }, [props.userDetails, navigate]);

  const showNotify = (msg, sev = "error") => {
    setSnackbar({ open: true, message: msg, severity: sev });
  };

  const handleCloseSnack = () => setSnackbar({ ...snackbar, open: false });

  const handleTabChange = (event, newValue) => {
    setIfOtp(newValue === 0);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !loading) LoginClick();
  };

  const LoginClick = () => {
    if (!ifOtp) login();
    else createOtp();
  };

  const login = async () => {
    setLoading(true);
    try {
      const l = await auth.login({ userName, password });
      if (l === "error" || (l && l.errorResponse)) {
        showNotify(l.errorResponse || "פרטי התחברות שגויים");
      } else {
        const u = await resultsService.getuserDetails();
        props.updateUserDetails(u?.data);
      }
    } catch (ex) {
      showNotify("שגיאת תקשורת");
    } finally {
      setLoading(false);
    }
  };

  const createOtp = async () => {
    setLoading(true);
    try {
      const l = await auth.sendOtp(userName);
      if (l === "error" || (l && l.errorResponse)) {
        showNotify(l.errorResponse || "חלה שגיאה ביצירת הסיסמא");
      } else if (l) {
        showNotify("חלה שגיאה ביצירת הסיסמא");
      } else {
        setOpenOtpDialog(true);
      }
    } catch (ex) {
      showNotify("שגיאה בשליחת קוד");
    } finally {
      setLoading(false);
    }
  };

  const handleOtpSubmit = async () => {
    setLoading(true);
    try {
      const l = await auth.checkOtp(userName, otpValue);
      if (l === "error" || (l && l.errorResponse)) {
        showNotify(l.errorResponse || "קוד שגוי");
        setOtpValue("");
      } else {
        setOpenOtpDialog(false);
        const u = await resultsService.getuserDetails();
        props.updateUserDetails(u?.data);
      }
    } catch (ex) {
      showNotify("שגיאה באימות");
    } finally {
      setLoading(false);
    }
  };

  const fieldStyle = {
    "& .MuiInputBase-input": {
      color: "#000000 !important",
      WebkitTextFillColor: "#000000 !important",
    },
    "& .MuiInputLabel-root": { color: "#000000 !important" },
    "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: "#e0e0e0" },
      "&:hover fieldset": { borderColor: "#f26322" },
      "&.Mui-focused fieldset": { borderColor: "#f26322" },
    },
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `linear-gradient(45deg, rgba(242, 99, 34, 0.8), rgba(20, 20, 20, 0.6)), url(${mokedShahal})`,
        backgroundSize: "cover",
        backgroundBlendMode: "multiply",
      }}
    >
      <Container maxWidth="xs">
        <Zoom in={true}>
          <Paper
            elevation={10}
            sx={{
              borderRadius: "2px",
              textAlign: "center",
              backgroundColor: "#fff",
              borderTop: "4px solid #f26322",
            }}
          >
            <Box sx={{ pt: 3, pb: 1 }}>
              <Box component="img" src={logo} sx={{ height: "60px" }} />
            </Box>
            <Tabs
              value={ifOtp ? 0 : 1}
              onChange={handleTabChange}
              variant="fullWidth"
              sx={{
                "& .MuiTab-root": { fontWeight: 600, color: "#000000" },
                "& .Mui-selected": { color: "#000000 !important" },
                "& .MuiTabs-indicator": { backgroundColor: "#f26322" },
              }}
            >
              <Tab label="קוד בנייד" />
              <Tab label="שם משתמש" />
            </Tabs>
            <Box
              sx={{
                p: 4,
                pt: 3,
                display: "flex",
                flexDirection: "column",
                gap: 2,
              }}
            >
              <TextField
                fullWidth
                size="small"
                label={ifOtp ? "תעודת זהות / UPIN" : "שם משתמש"}
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                onKeyDown={handleKeyDown}
                sx={fieldStyle}
              />
              {!ifOtp && (
                <Fade in={!ifOtp}>
                  <TextField
                    fullWidth
                    size="small"
                    type="password"
                    label="סיסמה"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={handleKeyDown}
                    sx={fieldStyle}
                  />
                </Fade>
              )}
              <Typography
                variant="caption"
                sx={{
                  textAlign: "left",
                  color: "#000000",
                  fontWeight: 500,
                  display: "block",
                }}
              >
                * ת.ז עבור לקוחות / UPIN עבור רופאים. <br /> אין צורך ב-0 בתחילת
                תעודת הזהות.
              </Typography>
              <Button
                variant="contained"
                onClick={LoginClick}
                disabled={loading}
                sx={{
                  py: 1,
                  px: 4,
                  alignSelf: "center",
                  minWidth: "160px",
                  backgroundColor: "#f26322",
                  borderRadius: "20px",
                  fontWeight: 700,
                  color: "#fff",
                }}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : ifOtp ? (
                  "שלח קוד"
                ) : (
                  "כניסה"
                )}
              </Button>
            </Box>
          </Paper>
        </Zoom>
      </Container>
      <Dialog
        open={openOtpDialog}
        onClose={() => !loading && setOpenOtpDialog(false)}
        dir="rtl"
      >
        <DialogTitle
          sx={{ textAlign: "center", fontWeight: 700, color: "#000000" }}
        >
          אימות בנייד
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body2"
            sx={{ mb: 2, textAlign: "center", color: "#000000" }}
          >
            הזן את הקוד שנשלח אליך
          </Typography>
          <TextField
            autoFocus
            fullWidth
            value={otpValue}
            onChange={(e) => setOtpValue(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleOtpSubmit()}
            sx={fieldStyle}
            inputProps={{
              style: {
                textAlign: "center",
                fontSize: "1.2rem",
                color: "#000000",
              },
              maxLength: 6,
            }}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
          <Button
            onClick={() => setOpenOtpDialog(false)}
            sx={{ color: "#000000" }}
          >
            ביטול
          </Button>
          <Button
            onClick={handleOtpSubmit}
            variant="contained"
            disabled={loading}
            sx={{ backgroundColor: "#f26322", color: "#fff" }}
          >
            {loading ? <CircularProgress size={20} color="inherit" /> : "אישור"}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnack}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnack}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

const mapStateToProps = (state) => ({ userDetails: state.userDetails });
const mapDispatchToProps = (dispatch) => ({
  updateUserDetails: (newDetails) =>
    dispatch({ type: "UPDATE_USER_DETAILS", payload: newDetails }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
